<div class="grid">
  <div class="col-12">
    <div class="card">
      <div class="p-datatable p-component p-datatable-hoverable-rows">
        <div class="p-datatable-header">
          <div class="flex align-items-center justify-content-end">
            <div class="flex flex-column md:flex-row justify-content-end">
              <button pButton label=" {{'common.filters' | transloco}}" class="p-button-secondary" icon="pi pi-sliders-h"
                      (click)="filtersVisible = !filtersVisible"></button>
            </div>
          </div>
        </div>
        <p-table #table [(first)]="first" [(rows)]="rows" [paginator]="true" (onFilter)="onFilter($event)"
                 [responsive]="true" [rowsPerPageOptions]="[10,25,50]" [totalRecords]="totalPermissions" [value]="permissions"
                 sortField="name" styleClass="p-datatable-striped">
          <ng-template pTemplate="header">
            <tr>
              <th scope="col">
                {{'attribute.name' | transloco}}</th>
              <th scope="col">
                {{'attribute.description' | transloco}}</th>
              <th scope="col" style="width: 10rem;"></th>
            </tr>
          </ng-template>
          <ng-template let-permission pTemplate="body">
            <tr *ngIf="!loadingPermissions && permission" class="p-selectable-row">
              <td>{{permission.name}}</td>
              <td>{{permission.description}}</td>
              <td>
                <div class="flex justify-content-end">
                  <button [disabled]=""
                          [routerLink]="'permissions/' + permission.permissionUuid + '/edit'"
                          class="p-button-rounded btn-primary-light mr-2" icon="pi pi-pencil"
                          pButton pRipple></button>
                </div>
              </td>
            </tr>
            <tr *ngIf="loadingPermissions">
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div *ngIf="totalPermissions == 0"
                 class="flex align-items-center justify-content-between">{{'pagination.empty' | transloco}}</div>
            <div *ngIf="totalPermissions > 0" class="flex align-items-center justify-content-between">
              {{'pagination.showing' | transloco}} {{first + 1}}
              {{'pagination.to' | transloco}} {{(first + rows) >= totalPermissions ? totalPermissions : (first + rows)}}
              {{'pagination.of' | transloco}} {{totalPermissions}}
              {{(totalPermissions > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
            </div>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

<p-sidebar [(visible)]="filtersVisible" [baseZIndex]="10000" [style]="{'width':'25em'}" position="right">
  <h2 style="margin-left: 10px">{{'common.filters' | transloco}}</h2>
  <div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="permissionname">{{'attribute.name' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input (keyup.enter)="filtersVisible = false; applyFilters()" [(ngModel)]="currentFilters.name" [focus]="filtersVisible" appAutoFocus class="w-full" id="permissionname"
               pInputText type="text">
      </div>
    </div>
    <div class="col-12">
      <p-button (onClick)="filtersVisible = false; applyFilters()" [disabled]="!currentFilters.name" label="{{'common.filter' | transloco}}"
                styleClass="p-button-primary mx-2 mt-2" type="button"></p-button>
      <p-button (click)="resetFilters(); filtersVisible = false; applyFilters()" label="{{'common.clear' | transloco}}"
                styleClass="p-button-danger" type="button"></p-button>
    </div>
  </div>
</p-sidebar>

